@if (control) {
  <mat-form-field appearance="outline">
    <mat-label>{{ label }}</mat-label>
    @if (prependPlusSingForPositives && control.value > 0) {
      <div class="text-input-plus-sign" [ngClass]="control.errors ? 'error-offset' : ''">+</div>
    }
    <input
      #input
      [type]="type"
      matInput
      [formControl]="control"
      [required]="required"
      (keydown)="keyDown($event)"
      (input)="formatInput()"
      [tabindex]="tabIndex"
      [placeholder]="placeholder"
    />
    @if (!control.pristine) {
      @for (error of control.errors | errorKeys; track error) {
        <mat-error>
          {{ messages[error] || error | translate }}
        </mat-error>
      }
    }
  </mat-form-field>
}
<div class="input-description">{{ description }}</div>
